// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UqT8i {\n  /* Aligns with Button component used for student demo mode */\n  padding: var(--space-100) var(--space-200);\n  border-radius: var(--radius-100);\n  border: 1px solid var(--border-color-accent);\n  height: var(--space-500);\n}\n\n._2pf5z {\n  padding: 0 !important;\n}\n\n._2pf5z:hover {\n    background-color: var(--surface-brand-hover);\n  }", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"anchorContainer": "UqT8i",
	"anchorButton": "_2pf5z"
};
export default ___CSS_LOADER_EXPORT___;
